import React, {Component} from 'react';
import '../css/navbar.css'
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import ExhibitionDesktop from './ExhibitionDesktop';
import ArtGalleryMobile from '../components/ArtGalleryMobile';
import ArtGalleryDesktop from '../components/ArtGalleryDesktop';
import {Link} from 'react-router';

class Exhibition extends Component
{
  constructor() {
  super();
  this.state = {
    width: window.innerWidth,
  };
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }
  handleWindowSizeChange = () => {
    if (window.innerWidth < 737 && this.state.width >= 737 || this.state.width < 737 && window.innerWidth >= 737) {
      this.setState({ width: window.innerWidth });
    }
  };
  render() {
    const { width } = this.state;
    const isMobile = width <= 737;
    if (isMobile) {
      return (
      <div className="main mobileview">
        <ArtGalleryMobile art={this.props.params.art} painting={this.props.params.painting ? this.props.params.painting : null}  />
      </div>
    )
    }
    else if (this.props.params.painting && !isMobile) {
      return (
        <ArtGalleryDesktop painting={this.props.params.painting} {...this.props} />
      )
    }
    return (
      <div className="main desktopview">
        <Link to="/art" className="button-times"><i className="fa fa-times fa-2x" /></Link>
        <div className="artgallery-container">
          <div className="outer">
            <div className="middle">
              <div className="inner">
                <ExhibitionDesktop art={this.props.params.art} currentSlide={this.props.currentSlide} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    }
}
export default Exhibition;



// WEBPACK FOOTER //
// ./src/pages/Exhibition.js